import script from "./DiffImprovementActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiffImprovementActions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__